import CompanyBody from "./components/CompanyBody/CompanyBody";
import DeactivateJob from "./components/DeactivateJob/DeactivateJob";
import JobBody from "./components/JobBody/JobBody";
import Report from "./components/Report/Report";

export default function Modal({
    action,
    link,
    type,
    edit,
    cancel,
}: {
    action: Function;
    link?: string;
    type: string;
    edit?: boolean;
    cancel?: Function;
}) {
    return (
        <>
            <div className="fixed w-full h-screen bg-black top-0 left-0 z-10 opacity-50"></div>
            <div className="fixed p-5 border border-gray w-96 shadow-lg rounded-md bg-white z-20 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <div className="mt-3 text-center">
                    {type === "report" ? (
                        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-warning-100 mb-4 border-8 border-warning-200">
                            <svg
                                width="22"
                                height="22"
                                viewBox="0 0 22 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-6 w-6 text-green-600"
                                stroke="#DC6803"
                            >
                                <path
                                    d="M11 7V11M11 15H11.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                    ) : (
                        <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
                            <svg
                                className="h-6 w-6 text-green-600"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M5 13l4 4L19 7"
                                ></path>
                            </svg>
                        </div>
                    )}
                    {type === "job" && <JobBody action={action} link={link} />}
                    {type === "deactivate" && <DeactivateJob link={link} />}
                    {type === "company" && (
                        <CompanyBody edit={edit} link={link} />
                    )}
                    {type === "report" && (
                        <Report action={action} cancel={cancel} />
                    )}
                </div>
            </div>
        </>
    );
}
